/**
 * Where `/` sends a signed-in user — story 0.5 AC-4.
 *
 * The route tree used to redirect to a hard-coded `CLIENTE_PADRAO`, which was fine
 * while every persona could see every tenant and wrong the moment they could not:
 * a Cliente persona holding only `orgao-b` would be marched into
 * `tribunal-de-justica` and met with AC-7's access-denied screen on login.
 *
 * Order of preference, and the reasoning for it:
 *  1. **the remembered tenant** — already revalidated against `{clientes}`, so a
 *     revoked client cannot come back from storage;
 *  2. **the user's first client** — arbitrary but always legitimate;
 *  3. **an empty state** — a user with no clients at all is a real configuration,
 *     not a crash. §5.2's sidebar has the same requirement.
 */
import { Navigate } from 'react-router'

import { useSession } from '@/auth/session'
import { clienteEmFoco } from '@/tenant/persistencia'

export function DestinoDeCliente() {
  const { sessao } = useSession()
  const clientes = sessao?.clientes ?? []

  // A precedência vive em `tenant/persistencia`. A sidebar resolve o cliente do
  // link com a MESMA função — foi a duplicação dessa regra que produziu o
  // `/cliente//finops` de 21/08.
  const destino = clienteEmFoco(clientes)

  if (!destino) {
    return (
      <section className="mx-auto max-w-lg py-16 text-center" role="status">
        <i className="ph ph-buildings text-iox-navy mb-4 block text-4xl" aria-hidden="true" />
        <h1 className="type-h2 text-iox-navy mb-2">Nenhum cliente atribuído</h1>
        <p className="type-body text-navy-600">
          Sua conta ainda não tem acesso a nenhum cliente. Peça a um administrador da plataforma
          para incluir você.
        </p>
      </section>
    )
  }

  // O ÍNDICE do cliente, e não `/finops`: é ele que escolhe a primeira tela que a
  // pessoa pode ver (`PrimeiraTelaDoCliente`). Um destino fixo, com as rotas
  // guardadas desde 14/10/2026, mandaria um grupo só de Orçamento em círculo.
  return <Navigate to={`/cliente/${destino}`} replace />
}
